/* tslint:disable */
/* eslint-disable */
/**
 * K2B
 * The K2B API description
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { RopTransportClassifier } from '../models/rop-transport-classifier';
import { getFromStorage } from '../../app/helpers';
/**
 * RopTransportClassifiersApi - axios parameter creator
 * @export
 */
export const RopTransportClassifiersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ropTransportClassifiersControllerFindAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rop-transport-classifers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");
            

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RopTransportClassifiersApi - functional programming interface
 * @export
 */
export const RopTransportClassifiersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ropTransportClassifiersControllerFindAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<RopTransportClassifier>>>> {
            const localVarAxiosArgs = await RopTransportClassifiersApiAxiosParamCreator(configuration).ropTransportClassifiersControllerFindAll(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RopTransportClassifiersApi - factory interface
 * @export
 */
export const RopTransportClassifiersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ropTransportClassifiersControllerFindAll(options?: AxiosRequestConfig): Promise<AxiosResponse<Array<RopTransportClassifier>>> {
            return RopTransportClassifiersApiFp(configuration).ropTransportClassifiersControllerFindAll(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RopTransportClassifiersApi - object-oriented interface
 * @export
 * @class RopTransportClassifiersApi
 * @extends {BaseAPI}
 */
export class RopTransportClassifiersApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RopTransportClassifiersApi
     */
    public async ropTransportClassifiersControllerFindAll(options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<RopTransportClassifier>>> {
        return RopTransportClassifiersApiFp(this.configuration).ropTransportClassifiersControllerFindAll(options).then((request) => request(this.axios, this.basePath));
    }
}
